"use client";

import { Player } from "@remotion/player";
import { useState, useEffect, type ComponentType } from "react";

interface RemotionPlayerProps {
  component: ComponentType;
  durationInFrames?: number;
  compositionWidth?: number;
  compositionHeight?: number;
  fps?: number;
  className?: string;
}

export default function RemotionPlayer({
  component,
  durationInFrames = 150,
  compositionWidth = 800,
  compositionHeight = 450,
  fps = 30,
  className,
}: RemotionPlayerProps) {
  const [mounted, setMounted] = useState(false);
  useEffect(() => setMounted(true), []);

  if (!mounted) {
    return (
      <div
        className={className}
        style={{
          aspectRatio: `${compositionWidth}/${compositionHeight}`,
          backgroundColor: "#f9fafb",
          borderRadius: 12,
        }}
      />
    );
  }

  return (
    <Player
      component={component}
      durationInFrames={durationInFrames}
      compositionWidth={compositionWidth}
      compositionHeight={compositionHeight}
      fps={fps}
      autoPlay
      loop
      style={{ width: "100%", borderRadius: 12 }}
      className={className}
    />
  );
}
